import { MarketTypeGroup } from "@/Overtime/enums/marketTypes"
import { SportFilter } from "@/Overtime/enums/markets"
import {
  BOTH_TEAMS_TO_SCORE_MARKET_TYPES,
  CARDS_MARKET_TYPES,
  CORNERS_MARKET_TYPES,
  DOUBLE_CHANCE_MARKET_TYPES,
  DRAW_NO_BET_MARKET_TYPES,
  EIGHTH_PERIOD_MARKET_TYPES,
  FIFTH_PERIOD_MARKET_TYPES,
  FIRST_PERIOD_MARKET_TYPES,
  FIRST_PERIOD_MARKET_TYPES2,
  FIRST_SEVEN_INNINGS_MARKET_TYPES,
  FIRST_THREE_INNINGS_MARKET_TYPES,
  FOURTH_PERIOD_MARKET_TYPES,
  FUTURES_MARKET_TYPES,
  MarketType,
  NINTH_PERIOD_MARKET_TYPES,
  PERIOD_MARKET_TYPES,
  PLAYER_PROPS_MARKET_TYPES,
  SECOND_PERIOD_MARKET_TYPES,
  SEVENTH_PERIOD_MARKET_TYPES,
  SGP_BUILDER_MARKET_TYPES,
  SIXTH_PERIOD_MARKET_TYPES,
  Sport,
  SPREAD_MARKET_TYPES,
  THIRD_PERIOD_MARKET_TYPES,
  TOTAL_MARKET_TYPES,
  TOTAL_ODD_EVEN_MARKET_TYPES,
  WINNER_MARKET_TYPES,
} from "overtime-utils"

export const MarketTypesBySportFilter: Record<SportFilter, MarketType[]> = {
  [SportFilter.Boosted]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Live]: [MarketType.WINNER, MarketType.SPREAD, MarketType.TOTAL],
  [SportFilter.Favourites]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.All]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Soccer]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.DOUBLE_CHANCE,
    MarketType.DRAW_NO_BET,
    MarketType.BOTH_TEAMS_TO_SCORE,
    MarketType.TOTAL_ODD_EVEN,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Football]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.TOTAL_ODD_EVEN,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Basketball]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.TOTAL_ODD_EVEN,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Baseball]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.WILL_THERE_BE_OVERTIME,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Hockey]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Fighting]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.SPREAD2,
    MarketType.GO_THE_DISTANCE,
    MarketType.WILL_FIGHT_END_IN_FIRST_MINUTE,
    MarketType.WILL_POINT_BE_DEDUCTED,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Tennis]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.TableTennis]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.eSports]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Rugby]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.AussieRules]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.TOTAL_ODD_EVEN,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Volleyball]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Handball]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.DOUBLE_CHANCE,
    MarketType.DRAW_NO_BET,
    MarketType.TOTAL_ODD_EVEN,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Waterpolo]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Cricket]: [
    MarketType.WINNER,
    MarketType.TOTAL_FOURS,
    MarketType.TOTAL_SIXES,
    MarketType.TOTAL_RUNS_OUTS,
    MarketType.MOST_FOURS,
    MarketType.MOST_SIXES,
    MarketType.MOST_RUNS_OUTS,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Motosport]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Golf]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Darts]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Lacrosse]: [
    MarketType.WINNER,
    MarketType.SPREAD,
    MarketType.TOTAL,
    MarketType.TOTAL_ODD_EVEN,
    ...FUTURES_MARKET_TYPES,
  ],
  [SportFilter.Politics]: [
    MarketType.WINNER,
    MarketType.US_ELECTION_POPULAR_VOTE_WINNER,
    MarketType.US_ELECTION_WINNING_PARTY,
  ],
  [SportFilter.Futures]: FUTURES_MARKET_TYPES,
  [SportFilter.PlayerProps]: PLAYER_PROPS_MARKET_TYPES,
  [SportFilter.QuickSgp]: SGP_BUILDER_MARKET_TYPES,
}

export const MarketTypeGroupsBySport: Record<
  Sport,
  Partial<Record<MarketTypeGroup, MarketType[]>>
> = {
  [Sport.SOCCER]: {
    [MarketTypeGroup.WINNER]: [
      ...WINNER_MARKET_TYPES,
      ...DOUBLE_CHANCE_MARKET_TYPES,
      MarketType.HALFTIME_FULLTIME,
    ],
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.DOUBLE_CHANCE]: DOUBLE_CHANCE_MARKET_TYPES,
    [MarketTypeGroup.DRAW_NO_BET]: DRAW_NO_BET_MARKET_TYPES,
    [MarketTypeGroup.BOTH_TEAMS_TO_SCORE]: BOTH_TEAMS_TO_SCORE_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_HALF]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_PROPS]: PLAYER_PROPS_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_GOALS]: [MarketType.PLAYER_PROPS_OVER_GOALS],
    [MarketTypeGroup.CORNERS]: CORNERS_MARKET_TYPES,
    [MarketTypeGroup.CARDS]: CARDS_MARKET_TYPES,
  },
  [Sport.BASKETBALL]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.GAME_PROPS]: [
      MarketType.TOTAL_STEALS,
      MarketType.TOTAL_BLOCKS,
      MarketType.TOTAL_ASSISTS,
      MarketType.TOTAL_MADE_THREES,
      MarketType.TOTAL_MADE_THREES_HOME_TEAM,
      MarketType.TOTAL_MADE_THREES_AWAY_TEAM,
    ],
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.PLAYER_PROPS]: PLAYER_PROPS_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_POINTS]: [
      MarketType.PLAYER_PROPS_POINTS,
      MarketType.PLAYER_PROPS_POINTS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS_ASSISTS,
    ],
    [MarketTypeGroup.PLAYER_REBOUNDS]: [
      MarketType.PLAYER_PROPS_REBOUNDS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS_ASSISTS,
      MarketType.PLAYER_PROPS_REBOUNDS_ASSISTS,
    ],
    [MarketTypeGroup.PLAYER_ASSISTS]: [
      MarketType.PLAYER_PROPS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS_ASSISTS,
      MarketType.PLAYER_PROPS_REBOUNDS_ASSISTS,
    ],
    [MarketTypeGroup.PLAYER_TURNOVERS]: [MarketType.PLAYER_PROPS_TURNOVERS],
    [MarketTypeGroup.PLAYER_BLOCKS]: [
      MarketType.PLAYER_PROPS_BLOCKS,
      MarketType.PLAYER_PROPS_STEALS_BLOCKS,
    ],
    [MarketTypeGroup.PLAYER_STEALS]: [
      MarketType.PLAYER_PROPS_STEALS,
      MarketType.PLAYER_PROPS_STEALS_BLOCKS,
    ],
    [MarketTypeGroup.PLAYER_THRESS]: [
      MarketType.PLAYER_PROPS_3PTS_MADE,
      MarketType.PLAYER_PROPS_THREES_ATTEMPTED,
    ],
    [MarketTypeGroup.PLAYER_TWO_POINTERS]: [
      MarketType.PLAYER_PROPS_MADE_TWO_POINTERS,
      MarketType.PLAYER_PROPS_TWO_POINTERS_ATTEMPTED,
    ],
    [MarketTypeGroup.PLAYER_FREE_THROWS]: [
      MarketType.PLAYER_PROPS_FREE_THROWS_MADE,
      MarketType.PLAYER_PROPS_FREE_THROWS_ATTEMPTED,
    ],
    [MarketTypeGroup.PLAYER_FIELD_GOALS]: [
      MarketType.PLAYER_PROPS_FIELD_GOALS_MADE,
      MarketType.PLAYER_PROPS_FIELD_GOALS_ATTEMPTED,
    ],
    [MarketTypeGroup.PLAYER_DOUBLE_DOUBLE]: [
      MarketType.PLAYER_PROPS_DOUBLE_DOUBLE,
    ],
    [MarketTypeGroup.PLAYER_TRIPLE_DOUBLE]: [
      MarketType.PLAYER_PROPS_TRIPLE_DOUBLE,
    ],
    [MarketTypeGroup.PLAYER_COMBOS]: [
      MarketType.PLAYER_PROPS_DOUBLE_DOUBLE,
      MarketType.PLAYER_PROPS_TRIPLE_DOUBLE,
      MarketType.PLAYER_PROPS_POINTS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS_ASSISTS,
      MarketType.PLAYER_PROPS_REBOUNDS_ASSISTS,
      MarketType.PLAYER_PROPS_STEALS_BLOCKS,
    ],
    [MarketTypeGroup.PLAYER_DEFENSE]: [
      MarketType.PLAYER_PROPS_BLOCKS,
      MarketType.PLAYER_PROPS_STEALS,
      MarketType.PLAYER_PROPS_STEALS_BLOCKS,
      MarketType.PLAYER_PROPS_TURNOVERS,
    ],
  },
  [Sport.FIGHTING]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.WINNING_METHOD]: [MarketType.METHOD_OF_VICTORY],
    [MarketTypeGroup.FIGHT_PROPS]: [
      MarketType.GO_THE_DISTANCE,
      MarketType.WILL_FIGHT_END_IN_FIRST_MINUTE,
      MarketType.WILL_POINT_BE_DEDUCTED,
      MarketType.PLAYER_PROPS_UFC_TAKEDOWNS_LANDED,
      MarketType.PLAYER_PROPS_UFC_SIGNIFICANT_STRIKES_LANDED,
    ],
    [MarketTypeGroup.ROUND_PROPS]: [MarketType.WINNING_ROUND],
  },
  [Sport.TENNIS]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.SETS]: [
      MarketType.TOTAL2,
      MarketType.SPREAD2,
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.GAMES]: [
      MarketType.TOTAL,
      MarketType.SPREAD,
      MarketType.TOTAL_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.FIRST_SET]: [
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.SECOND_SET]: [
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.THIRD_SET]: [
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
  },
  [Sport.TABLE_TENNIS]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.SETS]: [
      MarketType.TOTAL2,
      MarketType.SPREAD2,
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.POINTS]: [
      MarketType.TOTAL,
      MarketType.SPREAD,
      MarketType.TOTAL_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.FIRST_SET]: [
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.SECOND_SET]: [
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.THIRD_SET]: [
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
  },
  [Sport.FOOTBALL]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.PLAYER_TOUCHDOWN_SCORERS]: [
      MarketType.PLAYER_PROPS_FIRST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS_SCORER,
      MarketType.PLAYER_PROPS_LAST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS,
    ],
    [MarketTypeGroup.PLAYER_PASSING]: [
      MarketType.PLAYER_PROPS_PASSING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_TOUCHDOWNS,
      MarketType.PLAYER_PROPS_INTERCEPTIONS,
      MarketType.PLAYER_PROPS_PASSING_ATTEMPTS,
      MarketType.PLAYER_PROPS_PASSING_COMPLETIONS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
    ],
    [MarketTypeGroup.PLAYER_RUSHING]: [
      MarketType.PLAYER_PROPS_RUSHING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RUSH,
    ],
    [MarketTypeGroup.PLAYER_RECEIVING]: [
      MarketType.PLAYER_PROPS_RECEIVING_YARDS,
      MarketType.PLAYER_PROPS_RECEPTIONS,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RECEPTION,
    ],
    [MarketTypeGroup.PLAYER_DEFENSE_SPECIAL_TEAMS]: [
      MarketType.PLAYER_PROPS_SACKS,
      MarketType.PLAYER_PROPS_TACKLES,
    ],
    [MarketTypeGroup.PLAYER_KICKING]: [
      MarketType.PLAYER_PROPS_FIELD_GOALS_MADE,
      MarketType.PLAYER_PROPS_KICKING_POINTS,
      MarketType.PLAYER_PROPS_EXTRA_POINTS,
    ],
  },
  [Sport.BASEBALL]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.FIRST_INNING]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_FIVE_INNINGS]: FIRST_PERIOD_MARKET_TYPES2,
    [MarketTypeGroup.INNINGS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
      ...FIFTH_PERIOD_MARKET_TYPES,
      ...SIXTH_PERIOD_MARKET_TYPES,
      ...SEVENTH_PERIOD_MARKET_TYPES,
      ...EIGHTH_PERIOD_MARKET_TYPES,
      ...NINTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.PLAYER_PROPS]: PLAYER_PROPS_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_BATTER]: [
      MarketType.PLAYER_PROPS_HOMERUNS,
      MarketType.PLAYER_PROPS_HITS_RECORDED,
      MarketType.PLAYER_PROPS_BASES,
      MarketType.PLAYER_PROPS_RBIS,
      MarketType.PLAYER_PROPS_HITS_RUNS_RBIS,
      MarketType.PLAYER_PROPS_RUNS,
      MarketType.PLAYER_PROPS_STOLEN_BASES,
      MarketType.PLAYER_PROPS_BATTING_STRIKEOUTS,
      MarketType.PLAYER_PROPS_SINGLES,
      MarketType.PLAYER_PROPS_DOUBLES,
      MarketType.PLAYER_PROPS_BATTING_WALKS,
    ],
    [MarketTypeGroup.PLAYER_PITCHER]: [
      MarketType.PLAYER_PROPS_STRIKEOUTS,
      MarketType.PLAYER_PROPS_OUTS,
      MarketType.PLAYER_PROPS_PITCHER_HITS_ALLOWED,
      MarketType.PLAYER_PROPS_EARNED_RUNS,
      MarketType.PLAYER_PROPS_WALKS,
    ],
  },
  [Sport.HOCKEY]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.PLAYER_PROPS]: PLAYER_PROPS_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_POINTS]: [MarketType.PLAYER_PROPS_POINTS],
    [MarketTypeGroup.PLAYER_GOALS]: [MarketType.PLAYER_PROPS_GOALS],
    [MarketTypeGroup.PLAYER_SHOTS]: [MarketType.PLAYER_PROPS_SHOTS],
  },
  [Sport.ESPORTS]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.KILLS_PROPS]: [
      MarketType.PLAYER_PROPS_KILLS,
      MarketType.PLAYER_PROPS_1ST_MAP_KILLS,
      MarketType.PLAYER_PROPS_2ND_MAP_KILLS,
      MarketType.PLAYER_PROPS_3RD_MAP_KILLS,
      MarketType.PLAYER_PROPS_4TH_MAP_KILLS,
      MarketType.PLAYER_PROPS_5TH_MAP_KILLS,
      MarketType.PLAYER_PROPS_1ST_2_MAPS_KILLS,
      MarketType.PLAYER_PROPS_1ST_3_MAPS_KILLS,
    ],
    [MarketTypeGroup.ASSISTS_PROPS]: [
      MarketType.PLAYER_PROPS_ASSISTS,
      MarketType.PLAYER_PROPS_1ST_MAP_ASSISTS,
      MarketType.PLAYER_PROPS_2ND_MAP_ASSISTS,
      MarketType.PLAYER_PROPS_3RD_MAP_ASSISTS,
      MarketType.PLAYER_PROPS_4TH_MAP_ASSISTS,
      MarketType.PLAYER_PROPS_5TH_MAP_ASSISTS,
      MarketType.PLAYER_PROPS_1ST_2_MAPS_ASSISTS,
      MarketType.PLAYER_PROPS_1ST_3_MAPS_ASSISTS,
    ],
    [MarketTypeGroup.DEATHS_PROPS]: [
      MarketType.PLAYER_PROPS_DEATHS,
      MarketType.PLAYER_PROPS_1ST_MAP_DEATHS,
      MarketType.PLAYER_PROPS_2ND_MAP_DEATHS,
      MarketType.PLAYER_PROPS_3RD_MAP_DEATHS,
      MarketType.PLAYER_PROPS_4TH_MAP_DEATHS,
      MarketType.PLAYER_PROPS_5TH_MAP_DEATHS,
      MarketType.PLAYER_PROPS_1ST_2_MAPS_DEATHS,
      MarketType.PLAYER_PROPS_1ST_3_MAPS_DEATHS,
    ],
    [MarketTypeGroup.HEADSHOTS_PROPS]: [
      MarketType.PLAYER_PROPS_HEADSHOTS,
      MarketType.PLAYER_PROPS_1ST_MAP_HEADSHOTS,
      MarketType.PLAYER_PROPS_2ND_MAP_HEADSHOTS,
      MarketType.PLAYER_PROPS_3RD_MAP_HEADSHOTS,
      MarketType.PLAYER_PROPS_4TH_MAP_HEADSHOTS,
      MarketType.PLAYER_PROPS_5TH_MAP_HEADSHOTS,
      MarketType.PLAYER_PROPS_1ST_2_MAPS_HEADSHOTS,
      MarketType.PLAYER_PROPS_1ST_3_MAPS_HEADSHOTS,
    ],
  },
  [Sport.RUGBY]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.FIRST_HALF]: FIRST_PERIOD_MARKET_TYPES,
  },
  [Sport.AUSSIE_RULES]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.PLAYER_TOUCHDOWN_SCORERS]: [
      MarketType.PLAYER_PROPS_FIRST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS_SCORER,
      MarketType.PLAYER_PROPS_LAST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS,
    ],
    [MarketTypeGroup.PLAYER_PASSING]: [
      MarketType.PLAYER_PROPS_PASSING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_TOUCHDOWNS,
      MarketType.PLAYER_PROPS_INTERCEPTIONS,
      MarketType.PLAYER_PROPS_PASSING_ATTEMPTS,
      MarketType.PLAYER_PROPS_PASSING_COMPLETIONS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
    ],
    [MarketTypeGroup.PLAYER_RUSHING]: [
      MarketType.PLAYER_PROPS_RUSHING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RUSH,
    ],
    [MarketTypeGroup.PLAYER_RECEIVING]: [
      MarketType.PLAYER_PROPS_RECEIVING_YARDS,
      MarketType.PLAYER_PROPS_RECEPTIONS,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RECEPTION,
    ],
    [MarketTypeGroup.PLAYER_DEFENSE_SPECIAL_TEAMS]: [
      MarketType.PLAYER_PROPS_SACKS,
      MarketType.PLAYER_PROPS_TACKLES,
    ],
    [MarketTypeGroup.PLAYER_KICKING]: [
      MarketType.PLAYER_PROPS_FIELD_GOALS_MADE,
      MarketType.PLAYER_PROPS_KICKING_POINTS,
      MarketType.PLAYER_PROPS_EXTRA_POINTS,
    ],
  },
  [Sport.VOLLEYBALL]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SETS]: [
      MarketType.TOTAL2,
      MarketType.SPREAD2,
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
      MarketType.FIRST_PERIOD_SPREAD,
      MarketType.SECOND_PERIOD_SPREAD,
      MarketType.THIRD_PERIOD_SPREAD,
      MarketType.FIRST_PERIOD_TOTAL_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL_AWAY_TEAM,
    ],
    [MarketTypeGroup.POINTS]: [
      MarketType.TOTAL,
      MarketType.SPREAD,
      MarketType.TOTAL_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
      MarketType.FIRST_PERIOD_SPREAD,
      MarketType.SECOND_PERIOD_SPREAD,
      MarketType.THIRD_PERIOD_SPREAD,
      MarketType.FIRST_PERIOD_TOTAL_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL_AWAY_TEAM,
      MarketType.SECOND_PERIOD_TOTAL_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL_AWAY_TEAM,
      MarketType.THIRD_PERIOD_TOTAL_HOME_TEAM,
      MarketType.THIRD_PERIOD_TOTAL_AWAY_TEAM,
    ],
    [MarketTypeGroup.FIRST_SET]: [
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.FIRST_PERIOD_SPREAD,
      MarketType.FIRST_PERIOD_TOTAL_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_SET]: [
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_SPREAD,
      MarketType.SECOND_PERIOD_TOTAL_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL_AWAY_TEAM,
    ],
    [MarketTypeGroup.THIRD_SET]: [
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_SPREAD,
      MarketType.THIRD_PERIOD_TOTAL_HOME_TEAM,
      MarketType.THIRD_PERIOD_TOTAL_AWAY_TEAM,
    ],
  },
  [Sport.HANDBALL]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.DOUBLE_CHANCE]: DOUBLE_CHANCE_MARKET_TYPES,
    [MarketTypeGroup.DRAW_NO_BET]: DRAW_NO_BET_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_HALF]: SECOND_PERIOD_MARKET_TYPES,
  },
  [Sport.WATERPOLO]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
  },
  [Sport.CRICKET]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.PLAYER_PROPS]: PLAYER_PROPS_MARKET_TYPES,
  },
  [Sport.DARTS]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_PROPS]: PLAYER_PROPS_MARKET_TYPES,
  },
  [Sport.LACROSSE]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    // [MarketTypeGroup.QUICK_SGP]: [...SGP_BUILDER_MARKET_TYPES],
    [MarketTypeGroup.SGP]: [MarketType.WINNER_TOTAL],
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
  },
  [Sport.GOLF]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
  },
  [Sport.MOTOSPORT]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
  },
  [Sport.POLITICS]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
    [MarketTypeGroup.POPULAR_VOTE_WINNER]: [
      MarketType.US_ELECTION_POPULAR_VOTE_WINNER,
    ],
    [MarketTypeGroup.WINNING_PARTY]: [MarketType.US_ELECTION_WINNING_PARTY],
    [MarketTypeGroup.WINNING_PARTY_STATE]: [
      MarketType.US_ELECTION_WINNING_PARTY_ARIZONA,
      MarketType.US_ELECTION_WINNING_PARTY_GEORGIA,
      MarketType.US_ELECTION_WINNING_PARTY_MICHIGAN,
      MarketType.US_ELECTION_WINNING_PARTY_NEVADA,
      MarketType.US_ELECTION_WINNING_PARTY_PENNSYLVANIA,
      MarketType.US_ELECTION_WINNING_PARTY_WINSCONSIN,
      MarketType.US_ELECTION_WINNING_PARTY_NORTH_CAROLINA,
    ],
  },
  [Sport.FUTURES]: {
    [MarketTypeGroup.WINNER]: [MarketType.WINNER, ...FUTURES_MARKET_TYPES],
  },
  [Sport.EMPTY]: {
    [MarketTypeGroup.WINNER]: WINNER_MARKET_TYPES,
  },
}

export const MarketTypePlayerPropsGroupsBySport: Record<
  Sport,
  Partial<Record<MarketTypeGroup, MarketType[]>>
> = {
  [Sport.SOCCER]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.DOUBLE_CHANCE]: DOUBLE_CHANCE_MARKET_TYPES,
    [MarketTypeGroup.DRAW_NO_BET]: DRAW_NO_BET_MARKET_TYPES,
    [MarketTypeGroup.BOTH_TEAMS_TO_SCORE]: BOTH_TEAMS_TO_SCORE_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_HALF]: SECOND_PERIOD_MARKET_TYPES,
  },
  [Sport.BASKETBALL]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.GAME_PROPS]: [
      MarketType.TOTAL_STEALS,
      MarketType.TOTAL_BLOCKS,
      MarketType.TOTAL_ASSISTS,
      MarketType.TOTAL_MADE_THREES,
      MarketType.TOTAL_MADE_THREES_HOME_TEAM,
      MarketType.TOTAL_MADE_THREES_AWAY_TEAM,
    ],
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.PLAYER_POINTS]: [
      MarketType.PLAYER_PROPS_POINTS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS,
    ],
    [MarketTypeGroup.PLAYER_REBOUNDS]: [
      MarketType.PLAYER_PROPS_REBOUNDS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS,
      MarketType.PLAYER_PROPS_REBOUNDS_ASSISTS,
    ],
    [MarketTypeGroup.PLAYER_ASSISTS]: [
      MarketType.PLAYER_PROPS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_REBOUNDS_ASSISTS,
      MarketType.PLAYER_PROPS_POINTS_ASSISTS,
      MarketType.PLAYER_PROPS_REBOUNDS_ASSISTS,
    ],
    [MarketTypeGroup.PLAYER_TURNOVERS]: [MarketType.PLAYER_PROPS_TURNOVERS],
    [MarketTypeGroup.PLAYER_BLOCKS]: [
      MarketType.PLAYER_PROPS_BLOCKS,
      MarketType.PLAYER_PROPS_STEALS_BLOCKS,
    ],
    [MarketTypeGroup.PLAYER_STEALS]: [
      MarketType.PLAYER_PROPS_STEALS,
      MarketType.PLAYER_PROPS_STEALS_BLOCKS,
    ],
  },
  [Sport.FIGHTING]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.FIGHT_PROPS]: [
      MarketType.GO_THE_DISTANCE,
      MarketType.WILL_FIGHT_END_IN_FIRST_MINUTE,
      MarketType.WILL_POINT_BE_DEDUCTED,
      MarketType.PLAYER_PROPS_UFC_TAKEDOWNS_LANDED,
      MarketType.PLAYER_PROPS_UFC_SIGNIFICANT_STRIKES_LANDED,
    ],
  },
  [Sport.TENNIS]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.SETS]: [
      MarketType.TOTAL2,
      MarketType.SPREAD2,
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.GAMES]: [
      MarketType.TOTAL,
      MarketType.SPREAD,
      MarketType.TOTAL_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.FIRST_SET]: [
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.SECOND_SET]: [
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.THIRD_SET]: [
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
  },
  [Sport.TABLE_TENNIS]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.SETS]: [
      MarketType.TOTAL2,
      MarketType.SPREAD2,
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.POINTS]: [
      MarketType.TOTAL,
      MarketType.SPREAD,
      MarketType.TOTAL_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.FIRST_SET]: [
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.SECOND_SET]: [
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.THIRD_SET]: [
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
  },
  [Sport.FOOTBALL]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.PLAYER_TOUCHDOWN_SCORERS]: [
      MarketType.PLAYER_PROPS_FIRST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS_SCORER,
      MarketType.PLAYER_PROPS_LAST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS,
    ],
    [MarketTypeGroup.PLAYER_PASSING]: [
      MarketType.PLAYER_PROPS_PASSING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_TOUCHDOWNS,
      MarketType.PLAYER_PROPS_INTERCEPTIONS,
      MarketType.PLAYER_PROPS_PASSING_ATTEMPTS,
      MarketType.PLAYER_PROPS_PASSING_COMPLETIONS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
    ],
    [MarketTypeGroup.PLAYER_RUSHING]: [
      MarketType.PLAYER_PROPS_RUSHING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RUSH,
    ],
    [MarketTypeGroup.PLAYER_RECEIVING]: [
      MarketType.PLAYER_PROPS_RECEIVING_YARDS,
      MarketType.PLAYER_PROPS_RECEPTIONS,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RECEPTION,
    ],
    [MarketTypeGroup.PLAYER_DEFENSE_SPECIAL_TEAMS]: [
      MarketType.PLAYER_PROPS_SACKS,
      MarketType.PLAYER_PROPS_TACKLES,
    ],
    [MarketTypeGroup.PLAYER_KICKING]: [
      MarketType.PLAYER_PROPS_FIELD_GOALS_MADE,
      MarketType.PLAYER_PROPS_KICKING_POINTS,
      MarketType.PLAYER_PROPS_EXTRA_POINTS,
    ],
  },
  [Sport.BASEBALL]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_INNING]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_THREE_INNINGS]: FIRST_THREE_INNINGS_MARKET_TYPES,
    [MarketTypeGroup.FIRST_FIVE_INNINGS]: FIRST_PERIOD_MARKET_TYPES2,
    [MarketTypeGroup.FIRST_SEVEN_INNINGS]: FIRST_SEVEN_INNINGS_MARKET_TYPES,
    [MarketTypeGroup.INNINGS]: PERIOD_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_BATTER]: [
      MarketType.PLAYER_PROPS_HOMERUNS,
      MarketType.PLAYER_PROPS_BASES,
      MarketType.PLAYER_PROPS_HITS_RECORDED,
      MarketType.PLAYER_PROPS_RBIS,
      MarketType.PLAYER_PROPS_HITS_RUNS_RBIS,
      MarketType.PLAYER_PROPS_RUNS,
      MarketType.PLAYER_PROPS_STOLEN_BASES,
      MarketType.PLAYER_PROPS_BATTING_STRIKEOUTS,
      MarketType.PLAYER_PROPS_SINGLES,
      MarketType.PLAYER_PROPS_DOUBLES,
      MarketType.PLAYER_PROPS_BATTING_WALKS,
    ],
    [MarketTypeGroup.PLAYER_PITCHER]: [
      MarketType.PLAYER_PROPS_STRIKEOUTS,
      MarketType.PLAYER_PROPS_OUTS,
      MarketType.PLAYER_PROPS_PITCHER_HITS_ALLOWED,
      MarketType.PLAYER_PROPS_EARNED_RUNS,
      MarketType.PLAYER_PROPS_WALKS,
    ],
  },
  [Sport.HOCKEY]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
  },
  [Sport.ESPORTS]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
  },
  [Sport.RUGBY]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: FIRST_PERIOD_MARKET_TYPES,
  },
  [Sport.AUSSIE_RULES]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.PLAYER_TOUCHDOWN_SCORERS]: [
      MarketType.PLAYER_PROPS_FIRST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS_SCORER,
      MarketType.PLAYER_PROPS_LAST_TOUCHDOWN,
      MarketType.PLAYER_PROPS_TOUCHDOWNS,
    ],
    [MarketTypeGroup.PLAYER_PASSING]: [
      MarketType.PLAYER_PROPS_PASSING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_TOUCHDOWNS,
      MarketType.PLAYER_PROPS_INTERCEPTIONS,
      MarketType.PLAYER_PROPS_PASSING_ATTEMPTS,
      MarketType.PLAYER_PROPS_PASSING_COMPLETIONS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
    ],
    [MarketTypeGroup.PLAYER_RUSHING]: [
      MarketType.PLAYER_PROPS_RUSHING_YARDS,
      MarketType.PLAYER_PROPS_PASSING_RUSHING,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RUSH,
    ],
    [MarketTypeGroup.PLAYER_RECEIVING]: [
      MarketType.PLAYER_PROPS_RECEIVING_YARDS,
      MarketType.PLAYER_PROPS_RECEPTIONS,
      MarketType.PLAYER_PROPS_RUSHING_RECEIVING,
      MarketType.PLAYER_PROPS_LONGEST_RECEPTION,
    ],
    [MarketTypeGroup.PLAYER_DEFENSE_SPECIAL_TEAMS]: [
      MarketType.PLAYER_PROPS_SACKS,
      MarketType.PLAYER_PROPS_TACKLES,
    ],
    [MarketTypeGroup.PLAYER_KICKING]: [
      MarketType.PLAYER_PROPS_FIELD_GOALS_MADE,
      MarketType.PLAYER_PROPS_KICKING_POINTS,
      MarketType.PLAYER_PROPS_EXTRA_POINTS,
    ],
  },
  [Sport.VOLLEYBALL]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.SETS]: [
      MarketType.TOTAL2,
      MarketType.SPREAD2,
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.POINTS]: [
      MarketType.TOTAL,
      MarketType.SPREAD,
      MarketType.TOTAL_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL,
      MarketType.SECOND_PERIOD_TOTAL,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.FIRST_SET]: [
      MarketType.FIRST_PERIOD_WINNER,
      MarketType.FIRST_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.SECOND_SET]: [
      MarketType.SECOND_PERIOD_WINNER,
      MarketType.SECOND_PERIOD_TOTAL,
    ],
    [MarketTypeGroup.THIRD_SET]: [
      MarketType.THIRD_PERIOD_WINNER,
      MarketType.THIRD_PERIOD_TOTAL,
    ],
  },
  [Sport.HANDBALL]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.DOUBLE_CHANCE]: DOUBLE_CHANCE_MARKET_TYPES,
    [MarketTypeGroup.DRAW_NO_BET]: DRAW_NO_BET_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_HALF]: SECOND_PERIOD_MARKET_TYPES,
  },
  [Sport.WATERPOLO]: {},
  [Sport.CRICKET]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
  },
  [Sport.DARTS]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.PLAYER_PROPS]: PLAYER_PROPS_MARKET_TYPES,
  },
  [Sport.LACROSSE]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
    [MarketTypeGroup.HANDICAP]: SPREAD_MARKET_TYPES,
    [MarketTypeGroup.QUARTERS]: [
      ...FIRST_PERIOD_MARKET_TYPES,
      ...SECOND_PERIOD_MARKET_TYPES,
      ...THIRD_PERIOD_MARKET_TYPES,
      ...FOURTH_PERIOD_MARKET_TYPES,
    ],
    [MarketTypeGroup.FIRST_QUARTER]: FIRST_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.SECOND_QUARTER]: SECOND_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.THIRD_QUARTER]: THIRD_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FOURTH_QUARTER]: FOURTH_PERIOD_MARKET_TYPES,
    [MarketTypeGroup.FIRST_HALF]: [
      MarketType.FIRST_PERIOD_WINNER2,
      MarketType.FIRST_PERIOD_TOTAL2,
      MarketType.FIRST_PERIOD_SPREAD2,
      MarketType.FIRST_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.FIRST_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.FIRST_PERIOD_TOTAL2_AWAY_TEAM,
    ],
    [MarketTypeGroup.SECOND_HALF]: [
      MarketType.SECOND_PERIOD_WINNER2,
      MarketType.SECOND_PERIOD_TOTAL2,
      MarketType.SECOND_PERIOD_SPREAD2,
      MarketType.SECOND_PERIOD_TOTAL2_ODD_EVEN,
      MarketType.SECOND_PERIOD_TOTAL2_HOME_TEAM,
      MarketType.SECOND_PERIOD_TOTAL2_AWAY_TEAM,
    ],
  },
  [Sport.GOLF]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
  },
  [Sport.MOTOSPORT]: {
    [MarketTypeGroup.TOTALS]: [
      ...TOTAL_MARKET_TYPES,
      ...TOTAL_ODD_EVEN_MARKET_TYPES,
    ],
  },
  [Sport.POLITICS]: {
    [MarketTypeGroup.WINNING_PARTY_STATE]: [
      MarketType.US_ELECTION_WINNING_PARTY_ARIZONA,
      MarketType.US_ELECTION_WINNING_PARTY_GEORGIA,
      MarketType.US_ELECTION_WINNING_PARTY_MICHIGAN,
      MarketType.US_ELECTION_WINNING_PARTY_NEVADA,
      MarketType.US_ELECTION_WINNING_PARTY_PENNSYLVANIA,
      MarketType.US_ELECTION_WINNING_PARTY_WINSCONSIN,
      MarketType.US_ELECTION_WINNING_PARTY_NORTH_CAROLINA,
    ],
  },
  [Sport.FUTURES]: {},
  [Sport.EMPTY]: {},
}
